import { React, Fragment, useState, useEffect } from "react";
import {
  // DisablementAutoComplete,
  TitleBar,
  Dialog,
} from "webapp/components";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import TrxNowGoogleMap from "webapp/components/TrxNowMap/TrxNowGoogleMap";
import {
  apiGetAutocompleteList,
  apiRevGeocodeLocationGoogle,
  apiRevGeocodeLocationGoogleList,
  apiSubmitLocation,
} from "utils/API/TrxNowAPI";
import "./TTLocateUser.scss";
import { useRef } from "react";
import Modal from "react-responsive-modal";
import CircularProgress from "@mui/material/CircularProgress";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import { Alert } from "@mui/material";
import { AddressAutoComplete } from "webapp/components/AddressAutoComplete";
import { useCallback } from "react";
import { devLog } from "utils/devLog";
/**
 *
 * @param {
 *    callBackFunc - submit func generated in WebAppView
 *    logo - logo which is a partner is the result of the partner lookup
 * } props
 * @returns {
 *    disablementObj - more can be found D
 * }
 */
export default function TTLocateUser(props) {
  const { t } = useTranslation();

  const titleBarRef = useRef(null);
  const footerRef = useRef(null);
  const submitRef = useRef(null);
  const rotateTimeout = useRef(null);
  const confirmFadeTimeout = useRef(null);

  const [confirmFade, setConfirmFade] = useState(false);

  const [buttonOffset, setButtonOffset] = useState(0);

  /**
   * This flag should be set to TRUE when we have sucessfully GeoLocated the user or they select an address manually
   */
  const [userLocated, setUserLocated] = useState(false);

  const [loading, setLoading] = useState(true);

  const [retryGPSAttempts, setRetryGPSAttempts] = useState(0);

  /**
   * Stores the current lat/long as {lat:12.12318, lng: -54.968}
   */
  const [disablementCoords, setDisablementCoords] = useState(props.disablementCoords);
  // useState({
  //   lat: 39.82823463969616,
  //   lng: -98.57936168646332,
  // });

  /**
   * Stores the current lat/long as {lat:12.12318, lng: -54.968}
   */
  const [addressInput, setAddressInput] = useState("");

  /**
   * A boolean that stores whether the user has allowed GPS access or not
   */
  const [userDidNotGeoLocate, setUserDidNotGeoLocate] = useState(false);

  /**
   * This is where you store the user's address information through GPS
   */
  const [disablementAddress, setDisablementAddress] = useState(null);

  /**
   * This is where you store the user's address information through auto complete list
   */
  const [disablementAddressSearch, setDisablementAddressSearch] = useState(null);

  /**
   * This flag hides/shows the error dialog box
   */
  const [DialogFlag, setDialogFlag] = useState(false);

  /**
   * Height of the map view
   */
  const [mapHeight, setMapHeight] = useState(400);

  /**
   * Screen orientation
   */
  const [screenOrientation, setScreenOrientation] = useState("portrait");

  /**
   * Hide/Show spinner modal
   */
  const [showSpinner, setShowSpinner] = useState(false);

  /**
   * Hide/Show location sent modal
   */
  const [showLocationSent, setShowLocationSent] = useState(false);

  /**
   * Expired link modal
   */
  const [showExpiredMessage, setShowExpiredMessage] = useState(false);

  /**
   * GPS question asked modal
   */
  const [informGPSNeeded, setInformGPSNeeded] = useState(true);

  /**
   *
   */
  const [warnUserNotLocated, setWarnUserNotLocated] = useState(false);
  const [addressIncomplete, setAddressIncomplete] = useState(false);
  const [locationList, setLocationList] = useState([]);

  const [showOverlay, setShowOverlay] = useState(false);

  const [onHighway, setOnHighway] = useState("");
  const [data, setData] = useState({});
  const [showOnHighwayWarning, setShowOnHighwayWarning] = useState(false);

  /**
   * Tracks whether user has selected an address from the autocomplete list
   */
  const [addressSelectedFromList, setAddressSelectedFromList] = useState(false);
  const [showAddressSelectionWarning, setShowAddressSelectionWarning] = useState(false);

  /**
   * Attempts to get the lat/long from the user's device GPS
   * @returns {void}
   */
  const getCoords = () => {
    if (navigator.geolocation) {
      devLog("GeoLocation Available");
      navigator.geolocation.getCurrentPosition(locationSuccess, locationError, {
        enableHighAccuracy: true,
        // timeout: 2000,
        maximumAge: 0,
      });
    } else {
      devLog("GeoLocation not available");
      setUserDidNotGeoLocate(true);
    }
  };

  /**
   * Successfully got user's location through GPS
   * @param {GeolocationPosition} pos
   * @returns {void}
   */
  const locationSuccess = (pos) => {
    setUserDidNotGeoLocate(false);
    devLog("Success Callback Called", pos);
    setDisablementCoords({
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
    });
    setUserDidNotGeoLocate(false);
    reverseGeocode(pos.coords.latitude, pos.coords.longitude).then((addressResult) => {
      setLoading(false);
      setUserLocated(true);
      devLog("locationSuccess Address Result:", addressResult);
      setDisablementAddress(addressResult);
    });
  };

  /**
   * Failed to get user's location
   * @param {GeolocationPositionError} error
   * @returns {void}
   */
  const locationError = (error) => {
    devLog("Error getting coords:", error);
    if (error.code !== 3) {
      setUserDidNotGeoLocate(true);
      setUserLocated(false);
      setUserDidNotGeoLocate(true);
      setLoading(false);
    } else if (retryGPSAttempts <= 3) {
      setRetryGPSAttempts(retryGPSAttempts + 1);
      onInit();
    }
  };

  /**
   * This function is used to reverse geocode the user's location.
   * The passed in lat/long is then used to get the users's complete address from the TrxNow API
   * @param {number} lat
   * @param {number} lng
   * @returns {Promise<any>}
   */
  const reverseGeocode = (lat, lng) => {
    return new Promise((resolve, reject) => {
      apiRevGeocodeLocationGoogle({ lat: lat, lng: lng }, (addressResult) => {
        devLog("reverseGeocode Address Result:", addressResult);
        resolve(addressResult);
      });
    });
  };

  // Example: how to use the reverseGeocode function
  // reverseGeocode(lat, lng).then((addressResult) => {
  //  devLog("Address Result:", addressResult);
  // });

  const updateMapHeight = () => {
    let offset = 0;
    if (titleBarRef.current) {
      offset = titleBarRef.current.clientHeight;
    }
    devLog(offset, titleBarRef, footerRef);
    if (window?.screen?.orientation?.angle == 90) {
      setMapHeight(window.innerHeight - 50);
      setScreenOrientation("landscape");

      if (submitRef.current) {
        setButtonOffset(50 + -15);
      }
    } else {
      setMapHeight(window.innerHeight - offset);
      setScreenOrientation("portrait");

      if (submitRef.current) {
        setButtonOffset(offset + 33);
      }
    }
  };

  const onWindowResize = (e) => {
    updateMapHeight();

    clearTimeout(rotateTimeout.current);
    rotateTimeout.current = setTimeout(() => {
      updateMapHeight();
    }, 200);
  };

  /**
   * This useEffect is called when the component mounts/(is ready)
   */
  useEffect(() => {
    devLog("TTLocateUser: ready");
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    // onInit();

    onWindowResize();

    setTimeout(() => {
      setConfirmFade(true);
    }, 1500);

    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  useEffect(() => {
    devLog("disablementAddress useEffect: ", disablementAddress);
    if (disablementAddress) {
      setAddressInput(disablementAddress.title || disablementAddress.formatted_address);
    }
  }, [disablementAddress]);

  /**
   * This callback is called when the user clicks the `Confirm My Location` button
   * @returns {void}
   */
  const onSubmit = () => {
    devLog("onSubmit called disablementCoords", disablementCoords);
    devLog("onSubmit called disablementAddress", disablementAddress.address);

    let bHasRoute = false;
    let bHasPlusCode = false;
    let bHasCity = false;
    let bHasState = false;
    let bHasCountry = false;
    let bHasZip = false;

    let street = "";
    let streetNumber = "";
    let city = "";
    let state = "";
    let country = "";
    let zip = "";

    const addrComps = disablementAddress?.address_components ? disablementAddress.address_components : null;

    const addrInputComps = disablementAddress?.address ? disablementAddress.address : null;

    if (addrComps) {
      for (let j = 0, jLen = addrComps.length; j < jLen; j++) {
        const comp = addrComps[j];
        if (!comp || !Array.isArray(comp?.types)) {
          continue;
        }

        if (comp.types.indexOf("route") >= 0) {
          bHasRoute = true;
          devLog("street: ", comp.short_name);
          street = comp.short_name;
        } else if (comp.types.indexOf("intersection") >= 0) {
          bHasRoute = true;
          devLog("street: ", comp.short_name);
          street = comp.short_name;
        } else if (comp.types.indexOf("plus_code") >= 0) {
          bHasPlusCode = true;
          bHasRoute = true;
          devLog("street: ", comp.short_name);
          street = comp.short_name;
        } else if (comp.types.indexOf("street_number") >= 0) {
          devLog("streetNumber: ", comp.short_name);
          streetNumber = comp.long_name;
        } else if (comp.types.indexOf("locality") >= 0) {
          bHasCity = true;
          devLog("city: ", comp.short_name);
          city = comp.long_name;
        } else if (comp.types.indexOf("neighborhood") >= 0) {
          bHasCity = true;
          devLog("city: ", comp.short_name);
          city = comp.long_name;
        } else if (comp.types.indexOf("administrative_area_level_3") >= 0) {
          bHasCity = true;
          devLog("city: ", comp.short_name);
          city = comp.long_name;
        } else if (comp.types.indexOf("administrative_area_level_1") >= 0) {
          bHasState = true;
          devLog("state: ", comp.short_name);
          state = comp.long_name;
        } else if (comp.types.indexOf("country") >= 0) {
          bHasCountry = true;
          devLog("country: ", comp.short_name);
          country = comp.long_name;
        } else if (comp.types.indexOf("postal_code") >= 0) {
          bHasZip = true;
          devLog("zip: ", comp.short_name);
          zip = comp.long_name;
        }
      }
    } else if (addrInputComps) {
      if (addrInputComps.street) {
        bHasPlusCode = addrInputComps.street.includes("+");
        bHasRoute = true;
        street = addrInputComps.street;
      }
      if (addrInputComps.houseNumber) {
        streetNumber = addrInputComps.houseNumber;
      }
      if (addrInputComps.city) {
        bHasCity = true;
        city = addrInputComps.city;
      }
      if (addrInputComps.stateCode) {
        bHasState = true;
        state = addrInputComps.stateCode;
      }
      if (addrInputComps.postalCode) {
        bHasZip = true;
        zip = addrInputComps.postalCode;
      }
      if (addrInputComps.countryCode) {
        bHasCountry = true;
        country = addrInputComps.countryCode;
      }
    } else {
      console.error("disablementAddress.address_components is null");
      setDisablementAddress(null);
      setAddressIncomplete(true);
      return;
    }

    const validAddr = bHasRoute && bHasCity && bHasState && bHasCountry && bHasZip;

    if (props.context && disablementAddress && userLocated && validAddr) {
      // Check if user has selected an address from the autocomplete list
      if (!addressSelectedFromList) {
        setShowAddressSelectionWarning(true);
        return;
      }
      if (onHighway === "" || onHighway === undefined) {
        setShowOnHighwayWarning(true);
        return;
      }
      const context = props.context;
      context.setState(
        {
          // TTLObj: {
          //   lat: disablementCoords.lat,
          //   lng: disablementCoords.lng,
          //   street: disablementAddress.address.houseNumber
          //     ? disablementAddress.address.houseNumber +
          //       " " +
          //       disablementAddress.address.street
          //     : disablementAddress.address.street,
          //   city: disablementAddress.address.city,
          //   state: disablementAddress.address.stateCode,
          //   country: disablementAddress.address.countryCode,
          //   zip: disablementAddress.address.postalCode,
          TTLObj: {
            lat: disablementCoords.lat,
            lng: disablementCoords.lng,
            street: bHasPlusCode ? street : streetNumber ? streetNumber + " " + street : street,
            city: city,
            state: state,
            country: country,
            zip: zip,
          },
          OnHighway: onHighway.value === "true" ? true : false,
        },
        () => {
          devLog("props.currState", context.state);
          setShowSpinner(true);
          apiSubmitLocation(context.state, (body) => {
            setShowSpinner(false);
            setShowLocationSent(false);
            setShowExpiredMessage(false);
            if (body.error) {
              setShowExpiredMessage(true);
            } else {
              setShowLocationSent(true);
            }
            devLog("Location sent!", body);
          });
        },
      );
    }

    if (!userLocated) {
      setWarnUserNotLocated(true);
    }
  };

  /**
   * This callback is called when the user clicks the `OK` button
   * @returns {void}
   */
  const onDialogOK = () => {
    setDialogFlag(false);
  };

  const onLocationUpdate = (coords, locationData) => {
    devLog("onLocationUpdate:", coords, locationData);
    setDisablementCoords(coords);
    setDisablementAddress(locationData);
    setUserLocated(true);
  };

  const onInit = () => {
    setInformGPSNeeded(false);
    //if no value in disablement coords is present geolocate and generate one and set the coords
    if (disablementCoords === null) {
      getCoords();
    }
    //if a value is present for the coords, but none is present for the address reverse geocode the address
    else if (disablementCoords !== null && disablementAddress === null) {
      getCoords();
    }
  };

  const handleOnHighwayChange = (value) => {
    devLog("handleOnHighwayChange:", value);
    setOnHighway(value);
    setData({ onHighway: value });
  };

  const handleAddressSelectedChange = (isSelected) => {
    devLog("handleAddressSelectedChange:", isSelected);
    setAddressSelectedFromList(isSelected);
  };

  /**
   * legacy partner implementation which will be replaced by partner look up function
   */
  const LocateUserObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <Fragment>
        <p className="mb-0">
          <strong>{t("description.LocateUserTitleBar1")}</strong>
          <br />
          <span style={{ color: "#999" }}>{t("description.LocateUserTitleBar2")}</span>
        </p>
      </Fragment>
    ),
  };

  useEffect(() => {
    devLog("Disablement Coords are now:", props.disablementCoords);
    setDisablementCoords(props.disablementCoords);
    setAddressInput(props.addressLabel || "");
  }, [props.disablementCoords, props.addressLabel]);

  const getLocationList = (address, coords) => {
    if (address && coords) {
      apiGetAutocompleteList(address, coords.lat, coords.lng, (locationsList) => {
        if (typeof locationsList !== "object" || !Array.isArray(locationsList.results)) {
          setLocationList([]);
          return;
        }
        setLocationList(locationsList.results);
      });
    } else {
      setLocationList([]);
      return;
    }
  };

  // const onMarkerDragEnd = (newCoords) => {
  //   devLog("Marker dragged, new coords:", newCoords);
  //   setDisablementCoords(newCoords);
  //   setLoading(true);
  //   reverseGeocode(newCoords.lat, newCoords.lng).then((addressResult) => {
  //     setLoading(false);
  //     setUserLocated(true);
  //     devLog("Marker drag address result:", addressResult);
  //     setDisablementAddress(addressResult);
  //   });
  // };

  const [currZoom, setCurrZoom] = useState(17);
  const zoomChange = (newZoom) => {
    setCurrZoom(newZoom);
  };

  const onMarkerDragEnd = useCallback((newCoords) => {
    devLog("Marker dragged, new coords:", newCoords);
    setDisablementCoords(newCoords);
    setLoading(true);
    apiRevGeocodeLocationGoogleList(newCoords, (addressResult) => {
      devLog("apiRevGeocodeLocationGoogleList Address Result: ", addressResult);
      if (addressResult.length === 1) {
        setAddressInput(addressResult[0].address.label);
        setLocationList([]);
        setLoading(false);
      } else {
        setAddressInput("");
        setLoading(false);
        setLocationList(addressResult);
      }
    });
  }, []);

  const [displayAutoCompleteList, setDisplayAutoCompleteList] = useState(false);

  const onDisplayAutoCompleteList = useCallback((data) => {
    devLog("TTLocateUser onDisplayAutoCompleteList:", data);
    setDisplayAutoCompleteList(data);
  }, []);
  // const onLocationUpdate = (coords, locationData) => {
  //   devLog("onLocationUpdate:", coords, locationData);
  //   setDisablementCoords(coords);
  //   setDisablementAddress(locationData);
  //   setUserLocated(true);
  // };
  return (
    <div className={`TTLocateUser ${screenOrientation}`}>
      <Fragment>
        {/* This dialog notifies the user of an error with their address. This usually means our reverseGeocode function failed to turn the lat/long into a valid address */}
        {DialogFlag && (
          <Dialog
            config={true}
            title={"PaymentRequiredHeader1"}
            message={
              <Fragment>
                {t("description.DisablementErrorTitle")}
                <ul>
                  <li>{t("description.DisablementErrorText1")}</li>
                  setUserLocated
                  <li>{t("description.DisablementErrorText2")}</li>
                </ul>
              </Fragment>
            }
            onClose={onDialogOK}
            buttonTitle={"Close"}
          />
        )}

        {(showSpinner || loading) && (
          <Modal
            open={true}
            onClose={() => {}}
            closeOnEsc={false}
            center={true}
            closeOnOverlayClick={false}
            showCloseIcon={false}
          >
            <CircularProgress disableShrink />
          </Modal>
        )}
        {showLocationSent && (
          <Modal
            open={true}
            onClose={() => {}}
            closeOnEsc={false}
            center={true}
            closeOnOverlayClick={false}
            showCloseIcon={false}
          >
            <div className="text-center ">
              <div className="font-bold text-2xl pb-2">{t("description.LocationHasBeenSentTitle")}</div>
              <div className="mb-3">{t("description.LocationHasBeenSentMessage1")}</div>
              <div className="mb-3">{t("description.LocationHasBeenSentMessage2")}</div>
              <div className="mb-3">{t("description.LocationHasBeenSentMessage3")}</div>
            </div>
          </Modal>
        )}

        {showExpiredMessage && (
          <Modal
            open={true}
            onClose={() => {}}
            closeOnEsc={false}
            center={true}
            closeOnOverlayClick={false}
            showCloseIcon={false}
          >
            <div className="text-center ">
              <div className="font-bold text-2xl pb-2">{t("description.LocationTTLExpired")}</div>
            </div>
          </Modal>
        )}

        <Modal
          open={informGPSNeeded}
          onClose={() => {}}
          closeOnEsc={false}
          center={true}
          closeOnOverlayClick={false}
          showCloseIcon={false}
        >
          <div className="text-center">
            <ShareLocationIcon size={`large`} style={{ width: "56pt", height: "56pt" }} />
            <br />
            <br />
            <p>{t("description.LocationGPSNotice")}</p>
            <button
              className={`btn btn-primary btn-begin-ttl ${confirmFade ? "enabled" : ""}`}
              onClick={(e) => {
                onInit();
              }}
            >
              Continue
            </button>
          </div>
        </Modal>

        {/* Modal: User Did Not get location. They either have no GPS or the did not give us permission to access it. */}
        {userDidNotGeoLocate && (
          <Dialog
            title={"DeniedLocation"}
            message={"DeniedLocationTest"}
            buttonTitle={"HelpCallButton2"}
            //onClose={this.startButtonPressed}
          />
        )}

        {/* Modal: User Did Not get location. They either have no GPS or the did not give us permission to access it. */}
        {warnUserNotLocated && (
          <Dialog
            title={"DeniedLocation"}
            message={"DeniedLocationTest"}
            buttonTitle={"HelpCallButton2"}
            onClose={() => {
              setWarnUserNotLocated(false);
            }}
          />
        )}

        {showOnHighwayWarning && (
          <Dialog
            title={"OnHighwayErrorTitle"}
            message={"OnHighwayErrorMessage"}
            buttonTitle={"HelpCallButton2"}
            onClose={() => {
              setShowOnHighwayWarning(false);
            }}
          />
        )}

        {/* Modal: User must select an address from the autocomplete list */}
        {showAddressSelectionWarning && (
          <Dialog
            title={"AddressSelectionErrorTitle"}
            message={"AddressSelectionErrorMessage"}
            buttonTitle={"HelpCallButton2"}
            onClose={() => {
              setShowAddressSelectionWarning(false);
            }}
          />
        )}

        {/* Modal: User Did Not input a complete address */}
        {addressIncomplete && (
          <Dialog
            title={"DeniedLocation"}
            message={"IncompleteAddressMsg"}
            buttonTitle={"HelpCallButton2"}
            onClose={() => {
              setAddressIncomplete(false);
            }}
          />
        )}

        {/* The GoogleMap component */}
        <div className={`map-wrapper`} style={{ height: mapHeight }}>
          {disablementCoords && (
            <TrxNowGoogleMap
              showOverlay={showOverlay}
              setShowOverlay={setShowOverlay}
              disablementCoords={disablementCoords}
              height={mapHeight}
              zoom={currZoom}
              onZoomChange={(newZoom) => {
                zoomChange(newZoom);
              }}
              onMarkerDragEnd={onMarkerDragEnd}
              onDisplayAutoCompleteList={onDisplayAutoCompleteList}
            />
          )}
          <div className={`map-blocker ${!userLocated && !loading ? "on" : ""}`}>
            <div className="error text-center">
              <LocationOffIcon size={`large`} style={{ width: "56pt", height: "56pt" }} />
              <br />
              <p>{t("description.LocationTTLError")}</p>
            </div>
          </div>
        </div>

        <AddressAutoComplete
          locationList={locationList}
          handleOnHighwayChange={handleOnHighwayChange}
          onHighway={onHighway}
          addressInput={addressInput}
          getLocationList={getLocationList}
          currentLocation={disablementCoords}
          setShowOverlay={setShowOverlay}
          onLocationUpdate={onLocationUpdate}
          disablementAddress={disablementAddress}
          displayAutoCompleteList={displayAutoCompleteList}
          onDisplayAutoCompleteList={onDisplayAutoCompleteList}
          onAddressSelectedChange={handleAddressSelectedChange}
        />

        {/* Page Titlebar */}
        <div ref={titleBarRef}>
          <TitleBar data={LocateUserObj} />
        </div>

        {/* Footer Container - This wrapper contains the Confirm My Location submit button */}
        <div className="fab-container" ref={footerRef}>
          <button
            ref={submitRef}
            onClick={() => {
              onSubmit();
            }}
            className={`fab fab-submit ${!userLocated || loading ? "disabled" : ""}`}
            style={{
              bottom: buttonOffset ? buttonOffset : "revert-layer",
            }}
          >
            <span
              style={{
                marginLeft: "0px",
              }}
            >
              {t("description.LocationTTLSubmitButton")}
            </span>
          </button>
        </div>
      </Fragment>
    </div>
  );
}
